import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/action/edit.svg'
import _imports_1 from '@/assets/img/icon/delete-lines-red.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "border-grey-3 background-white p-4 form-content" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "w-full lg:w-3/5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold mb-16px" }, "Informasi Paket", -1)
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Nama Paket", -1)
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Masa Aktif Paket", -1)
const _hoisted_12 = { class: "grid grid-cols-2 gap-4 mb-4" }
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "bundleMode1",
  class: "ml-2"
}, "Hari", -1)
const _hoisted_15 = { class: "flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "bundleMode2",
  class: "ml-2"
}, "Tanggal (mengikuti tanggal publish)", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-inputgroup flex-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Hari", -1)
const _hoisted_20 = { class: "invalid-feedback" }
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Max Pembelian", -1)
const _hoisted_23 = { class: "p-inputgroup flex-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Kali", -1)
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Tanggal Publish Paket di Aplikasi", -1)
const _hoisted_28 = { class: "flex items-center gap-2" }
const _hoisted_29 = { class: "w-2/5" }
const _hoisted_30 = { class: "p-inputgroup flex-1" }
const _hoisted_31 = { class: "p-inputgroup-addon" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-center" }, "s.d.", -1)
const _hoisted_35 = { class: "w-2/5" }
const _hoisted_36 = { class: "p-inputgroup flex-1" }
const _hoisted_37 = { class: "p-inputgroup-addon" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "invalid-feedback" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal required" }, "Keterangan", -1)
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal" }, "Aktif", -1)
const _hoisted_44 = { class: "w-full lg:w-2/5 border-grey-3 rounded-lg p-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold mb-20px" }, "Daftar Item", -1)
const _hoisted_46 = {
  key: 0,
  class: "text-xs tetx-grey italic text-center"
}
const _hoisted_47 = { class: "xl:flex items-center justify-between gap-2" }
const _hoisted_48 = { class: "flex items-center gap-1" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "md:flex items-center gap-1 break-all" }
const _hoisted_51 = { class: "text-sm font-bold" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:block text-grey" }, "|", -1)
const _hoisted_53 = { class: "text-sm font-extrabold text-primary" }
const _hoisted_54 = { class: "flex items-center gap-2 w-50px" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  class: "pt-2 border-top-grey-3"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "flex items-center justify-between" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Trayek", -1)
const _hoisted_63 = { class: "text-11px font-semibold" }
const _hoisted_64 = { class: "flex items-center justify-between" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Kelas", -1)
const _hoisted_66 = { class: "text-11px font-semibold" }
const _hoisted_67 = { class: "flex items-center justify-between" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Jenis Penumpang", -1)
const _hoisted_69 = { class: "text-11px font-semibold" }
const _hoisted_70 = { class: "flex items-center justify-between" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Asal - Tujuan", -1)
const _hoisted_72 = { class: "flex items-center gap-2" }
const _hoisted_73 = { class: "text-11px font-semibold" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  key: 1,
  class: "text-11px font-semibold"
}
const _hoisted_76 = { class: "flex items-center justify-between" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Harga & Jumlah Item", -1)
const _hoisted_78 = { class: "text-11px font-semibold" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "flex items-center justify-between" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Snack", -1)
const _hoisted_82 = { class: "text-11px font-semibold" }
const _hoisted_83 = { class: "flex items-center justify-between" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Harga & Jumlah Item", -1)
const _hoisted_85 = { class: "text-11px font-semibold" }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { class: "flex items-center justify-between" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Voucher", -1)
const _hoisted_89 = { class: "text-11px font-semibold" }
const _hoisted_90 = { class: "flex items-center justify-between" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-11px font-normal" }, "Harga & Jumlah Item", -1)
const _hoisted_92 = { class: "text-11px font-semibold" }
const _hoisted_93 = { class: "flex justify-center mt-4" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Item'), -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "background-white p-4" }
const _hoisted_98 = {
  class: "flex items-center justify-between",
  style: {"width":"inherit"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-xs font-normal" }, "Harga akhir paket", -1)
const _hoisted_100 = { class: "text-2xl text-primary font-extrabold" }
const _hoisted_101 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_102 = { class: "discount-label" }
const _hoisted_103 = { class: "text-red line-through font-bold" }
const _hoisted_104 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_107 = { class: "flex items-center gap-4 mb-2 cursor-pointer" }
const _hoisted_108 = ["src"]
const _hoisted_109 = ["src"]
const _hoisted_110 = ["src"]
const _hoisted_111 = ["onClick"]

import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import Button from 'primevue/button'
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import InputSwitch from 'primevue/inputswitch'
import Textarea from 'primevue/textarea'
import RadioButton from 'primevue/radiobutton'
import { onMounted, ref, getCurrentInstance, watch, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Form, Field, useField } from 'vee-validate'
import * as Yup from 'yup'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { isNull, debounce } from 'lodash'
import moment from 'moment'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { DatePicker } from 'v-calendar'
import InputIconRightNoBorder from '@/views/components/form/InputIconRightNoBorder.vue'
import InputIconRightWhite from '@/views/components/form/InputIconRightWhite.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import rgxExp from '@/utils/helpers/regExp'
import OverlayPanel from 'primevue/overlaypanel'
import ItemForm from './ItemForm.vue'
import VoucherForm from './VoucherForm.vue'
import SnackForm from './SnackForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const backRouteName = 'ticket-subscription'
const bundleEndpoint = 'ticket/v1/Bundles'
const app = getCurrentInstance()
const {
  $icon, $toast, $confirm
} = app!.appContext.config.globalProperties
const icon = $icon
const store = useStore()
const route = useRoute()
const router = useRouter()
const idPrams = ref(null) as any
const showDialog = ref(false)
const selectedItem = ref(null) as any
const selectedItemEdit = ref(null) as any
const selectedItemData = ref(null) as any
const itemList = ref([]) as any
const isActive = ref(true)
const nettPrice = ref(0)
const brutoPrice = ref(0)
const totalDiscount = ref(0)
const activationDate = ref(moment().add(1, 'days').format('YYYY-MM-DD'))
const isLoading = ref(false)
const bundleTypes = ref([]) as any
const op = ref()
const selectedBundleType = ref(null) as any
const bundleExpirationMode = ref('BasedOnValidityDays')

const initialValues = ref({
  Name: '',
  ActivePeriod: 0,
  Notes: '',
  StartPublishDate: null as any,
  EndPublishDate: null as any,
  MaxPurchasePerUser: 0
})

const schema = Yup.object().shape({
  Name: Yup.string().transform((val) => (val === '' ? undefined : val)).required('Nama Paket harus diisi')
    .matches(rgxExp.notPrefixSpace, 'Nama Paket tidak boleh hanya menggunakan spasi')
    .min(3, 'Nama Paket minimal 3 karakter')
    .max(50, 'Nama Paket maksimal 50 karakter')
    .test('unique-name', 'Nama Paket sudah digunakan', async (val) => {
      if (!val) return true
      if (val.length < 3) return true
      try {
        const res = await apiOpenUseCase.get(`${bundleEndpoint}${returnUrlPrams({
          custom: [['q', '=', val]]
        })}`)
        const filterResult = res.result.filter((x: any) => x.BundleName === val && x.Id !== idPrams.value?.Id)
        if (route.params.id) {
          return filterResult.length === 0 || val === initialValues.value.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  ActivePeriod: Yup.lazy(() => (bundleExpirationMode.value === 'BasedOnValidityDays'
    ? Yup.number().typeError('Masa Aktif Paket harus diisi')
      .min(1, 'Masa Aktif Paket harus lebih dari 0')
      .max(99999, 'Masa Aktif Paket maksimal 5 digit angka')
    : Yup.mixed().notRequired())),
  Notes: Yup.string().typeError('Keterangan harus diisi').required('Keterangan harus diisi')
    .matches(rgxExp.notPrefixSpace, 'Nama Paket tidak boleh hanya menggunakan spasi')
    .min(5, 'Keterangan minimal 5 karakter')
    .max(255, 'Keterangan tidak boleh lebih dari 255 karakter'),
  StartPublishDate: Yup.string().required('Tanggal Awal Publish tidak boleh kosong'),
  EndPublishDate: Yup.string().required('Tanggal Akhir Publish tidak boleh kosong'),
  MaxPurchasePerUser: Yup.number().typeError('Jumlah Maksimal Pembelian per Pengguna harus diisi')
    .min(0, 'Jumlah Maksimal Pembelian per Pengguna harus lebih dari atau sama dengan 0')
    .max(9, 'Jumlah Maksimal Pembelian per Pengguna maksimal 9')
})

const { value: nameValue, errorMessage, validate } = useField('Name')
const validateNameDebounced = debounce(() => {
  // panggil validate() dari useField untuk memicu validasi schema (termasuk async .test)
  validate()
}, 600)

const changeIsActive = (val: any) => {
  console.log('isTrue', val)
}

const showDialogAct = () => {
  showDialog.value = true
}

const hideDialogAct = () => {
  selectedItemEdit.value = null
  selectedItemData.value = null
  showDialog.value = false
  selectedBundleType.value = null
}

const toMasterList = () => {
  router.push({ name: 'ticket-subscription' })
}

const addItem = (data: any) => {
  console.log('data', data)
  selectedBundleType.value = data.value
  showDialogAct()
}

const deleteItemAct = async (itemId: string) => {
  store.dispatch('showLoading')
  await apiOpenUseCase.delete(`${bundleEndpoint}/${idPrams.value.Id}/Items`, itemId).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Item berhasil dihapus',
        group: 'bc',
        closable: false,
        life: 3000
      })
      // eslint-disable-next-line no-use-before-define
      getBundleData()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal!',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const deleteItem = (data: any, index: any) => {
  $confirm.require({
    header: 'Hapus Item',
    message: 'Apakah anda yakin ingin menghapusnya?',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      if (idPrams.value && data?.Id) {
        await deleteItemAct(data?.Id)
      } else {
        itemList.value.splice(index, 1)
        $toast.add({
          severity: 'success',
          detail: 'Item berhasil dihapus',
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    }
  })
}

const editItem = (data: any, index: any) => {
  console.log('editItem', [data, index])
  // selectedBundleType.value = data.BundleItemType === 'Bus' ? 1 : 2
  switch (data.BundleItemType) {
    case 'Voucher':
      selectedBundleType.value = 2
      break
    case 'Snack':
      selectedBundleType.value = 3
      break
    default:
      selectedBundleType.value = 1
      break
  }
  selectedItemEdit.value = index
  selectedItemData.value = data
  showDialogAct()
}

const onSubmitAct = async (values: any, listItem: any) => {
  store.dispatch('showLoading')
  const listItemTemp = listItem

  const bundleItems = listItemTemp.map((data: any) => ({
    BundleItemType: data.BundleItemType,
    DisplayName: data.DisplayName,
    Quantity: data.Quantity,
    OriginalPrice: data.OriginalPrice,
    BundlePrice: data.BundlePrice,
    IsActive: true,
    BundleItemRoutes: data.BundleItemRoutes.length > 0 ? data.BundleItemRoutes.map((dataRoutes: any) => ({
      TrayekId: dataRoutes.TrayekId,
      TrayekName: dataRoutes.TrayekName,
      RouteId: dataRoutes.RouteId,
      RouteName: dataRoutes.RouteName,
      ClassId: dataRoutes.ClassId,
      ClassName: dataRoutes.ClassName,
      PassengerTypeId: dataRoutes.PassengerTypeId,
      PassengerTypeName: dataRoutes.PassengerTypeName,
      OriginStationId: dataRoutes.OriginStationId,
      OriginStationCode: dataRoutes.OriginStationCode,
      OriginStationName: dataRoutes.OriginStationName,
      OriginCityId: dataRoutes.OriginCityId,
      OriginCityCode: dataRoutes.OriginCityCode,
      OriginCityName: dataRoutes.OriginCityName,
      DestinationStationId: dataRoutes.DestinationStationId,
      DestinationStationCode: dataRoutes.DestinationStationCode,
      DestinationStationName: dataRoutes.DestinationStationName,
      DestinationCityId: dataRoutes.DestinationCityId,
      DestinationCityCode: dataRoutes.DestinationCityCode,
      DestinationCityName: dataRoutes.DestinationCityName
    })) : [],
    BundleItemVoucher: data.BundleItemVoucher ?? null,
    BundleItemSnack: data.BundleItemSnack ?? null
  }))
  let payload = null as any
  if (!idPrams.value) {
    payload = {
      BundleName: values.Name,
      Description: values.Notes,
      ActivationDate: activationDate.value,
      BundleExpirationMode: bundleExpirationMode.value,
      ValidityDays: values.ActivePeriod ?? 0,
      StartDate: moment(values.StartPublishDate).format('YYYY-MM-DD'),
      EndDate: moment(values.EndPublishDate).format('YYYY-MM-DD'),
      IsActive: isActive.value,
      MaxPurchasePerUser: values.MaxPurchasePerUser > 1 ? values.MaxPurchasePerUser : null,
      BundleMaxPurchaseType: values.MaxPurchasePerUser > 0 ? 'Limited' : 'Unlimited',
      BundleItems: bundleItems
    }
  } else {
    payload = {
      BundleName: values.Name,
      Description: values.Notes,
      BundleExpirationMode: bundleExpirationMode.value,
      ActivationDate: activationDate.value,
      ValidityDays: values.ActivePeriod ?? 0,
      StartDate: moment(values.StartPublishDate).format('YYYY-MM-DD'),
      EndDate: moment(values.EndPublishDate).format('YYYY-MM-DD'),
      IsActive: isActive.value,
      MaxPurchasePerUser: values.MaxPurchasePerUser > 1 ? values.MaxPurchasePerUser : null,
      BundleMaxPurchaseType: values.MaxPurchasePerUser > 0 ? 'Limited' : 'Unlimited'
    }
  }

  await apiOpenUseCase.postOrPut(`${bundleEndpoint}`, idPrams.value?.Id, payload).then((response) => {
    const { error, message } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Paket Langganan berhasil disimpan',
        group: 'bc',
        closable: false,
        life: 3000
      })
      toMasterList()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal!',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onSubmit = (values: any) => {
  if (itemList.value.length > 0) {
    $confirm.require({
      header: `${idPrams.value ? 'Edit' : 'Tambah'} Paket Langganan`,
      message: `Apakah anda yakin ingin ${idPrams.value ? 'mengubahnya' : 'menambahkannya'}?`,
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        onSubmitAct(values, itemList.value)
      }
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: 'Daftar Item masih kosong. Silahkan tambahkan Daftar Item terlebih dahulu sebelum disimpan.',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const addItemListAct = (data: any, index: any) => {
  if (!isNull(index)) {
    itemList.value[index] = data
  } else {
    itemList.value.push(data)
  }
}

const showItemDetail = (index: any) => {
  if (selectedItem.value === index) {
    selectedItem.value = null
  } else {
    selectedItem.value = index
  }
}

const initForm = (data: any) => {
  initialValues.value.Name = data.BundleName
  initialValues.value.ActivePeriod = data.ValidityDays
  initialValues.value.Notes = data.Description
  initialValues.value.StartPublishDate = new Date(data.StartDate)
  initialValues.value.EndPublishDate = new Date(data.EndDate)
  initialValues.value.MaxPurchasePerUser = data.MaxPurchasePerUser ?? 0
  itemList.value = data.BundleItems
  isActive.value = data.IsActive
  bundleExpirationMode.value = data.BundleExpirationMode

  if (itemList.value.length > 0) {
    brutoPrice.value = itemList.value.reduce((total: any, item: any) => total + (item.OriginalPrice), 0)
    nettPrice.value = itemList.value.reduce((total: any, item: any) => total + (item.BundlePrice), 0)
    totalDiscount.value = Math.round(((brutoPrice.value - nettPrice.value) / brutoPrice.value) * 100)
  }

  isLoading.value = false
}

const getBundleData = async () => {
  await apiOpenUseCase.get(`${bundleEndpoint}/${idPrams.value.Id}`).then((response) => {
    const { error, result, message } = response
    if (!error) {
      initForm(result)
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Gagal!',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
      toMasterList()
    }
  })
}

const getBundleItemTypes = async () => {
  store.dispatch('showLoading')
  try {
    await apiOpenUseCase.get(`${bundleEndpoint}/BundleItemTypes`).then((response) => {
      const { error, result } = response
      if (!error) {
        // eslint-disable-next-line array-callback-return
        result.map((data: any) => {
          const obj = { ...data, label: data.Name, value: data.Value }
          bundleTypes.value.push(obj)
        })
      }
    })
  } catch (error) {
    console.log('error', error)
  }
  store.dispatch('hideLoading')
}

const showDropdown = (evt: any) => {
  console.log('item', evt)
  // dataRow.value = item
  op.value.toggle(evt)
}

watch(itemList.value, (data) => {
  console.log('watch', data)
  if (itemList.value.length > 0) {
    brutoPrice.value = itemList.value.reduce((total: any, item: any) => total + (item.OriginalPrice), 0)
    nettPrice.value = itemList.value.reduce((total: any, item: any) => total + (item.BundlePrice), 0)
    totalDiscount.value = Math.round(((brutoPrice.value - nettPrice.value) / brutoPrice.value) * 100)
  }
})

onMounted(() => {
  getBundleItemTypes()
  let editOrAdd = 'Tambah'
  if (route.params.id) {
    isLoading.value = true
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    editOrAdd = 'Edit'
    getBundleData()
  }
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Karcis Langganan',
      routeName: backRouteName
    },
    {
      title: `${editOrAdd} Paket`,
      routeName: `${backRouteName}-form`
    }
  ])
})

// cancel debounce saat component unmount
onUnmounted(() => {
  validateNameDebounced.cancel()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues.value,
            validateOnInput: false,
            "validate-on-mount": false,
            class: "form-container"
          }, {
            default: _withCtx(({ errors, setFieldValue, values, meta }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_unref(InputText), {
                            value: values.Name,
                            onInput: (e) => {
                      setFieldValue('Name', e.target.value)
                      _unref(validateNameDebounced)()
                    },
                            onBlur: _cache[0] || (_cache[0] = (e) => {
                      _unref(validateNameDebounced).flush()
                    }),
                            placeholder: "Masukkan nama paket",
                            autocomplete: "off"
                          }, null, 8, ["value", "onInput"]),
                          (errors.Name && meta.touched)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(errors.Name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_unref(RadioButton), {
                                modelValue: bundleExpirationMode.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bundleExpirationMode).value = $event)),
                                inputId: "bundleMode1",
                                value: "BasedOnValidityDays"
                              }, null, 8, ["modelValue"]),
                              _hoisted_14
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_unref(RadioButton), {
                                modelValue: bundleExpirationMode.value,
                                "onUpdate:modelValue": [
                                  _cache[2] || (_cache[2] = ($event: any) => ((bundleExpirationMode).value = $event)),
                                  (v) => setFieldValue('ActivePeriod', 0)
                                ],
                                inputId: "bundleMode2",
                                value: "BasedOnPublishEndDate"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _hoisted_16
                            ])
                          ]),
                          (bundleExpirationMode.value === 'BasedOnValidityDays')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_unref(Field), { name: "ActivePeriod" }, {
                                  default: _withCtx(({ field, handleChange, handleBlur }) => [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_unref(InputNumber), {
                                        modelValue: values.ActivePeriod,
                                        "onUpdate:modelValue": ($event: any) => ((values.ActivePeriod) = $event),
                                        class: _normalizeClass(`${errors.ActivePeriod ? 'input-invalid' : ''}`),
                                        id: "ActivePeriod",
                                        placeholder: "0",
                                        min: 0,
                                        currency: "IDR",
                                        locale: "id-ID",
                                        step: 0.25,
                                        inputId: "refund-amount",
                                        onInput: (v) => {
                          setFieldValue('ActivePeriod', v.value)
                        },
                                        onBlur: field.onBlur,
                                        allowEmpty: false,
                                        autocomplete: "off"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"]),
                                      _hoisted_19
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", _hoisted_20, _toDisplayString(errors.ActivePeriod), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode(_unref(Field), { name: "MaxPurchasePerUser" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_unref(InputNumber), {
                                  modelValue: values.MaxPurchasePerUser,
                                  "onUpdate:modelValue": ($event: any) => ((values.MaxPurchasePerUser) = $event),
                                  class: _normalizeClass(`${errors.MaxPurchasePerUser ? 'input-invalid' : ''}`),
                                  id: "MaxPurchasePerUser",
                                  placeholder: "0",
                                  min: 0,
                                  currency: "IDR",
                                  locale: "id-ID",
                                  step: 1,
                                  inputId: "refund-amount",
                                  onInput: (v) => {
                          setFieldValue('MaxPurchasePerUser', v.value)
                        },
                                  allowEmpty: false,
                                  autocomplete: "off"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onInput"]),
                                _hoisted_24
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(errors.MaxPurchasePerUser), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_unref(Field), { name: "StartPublishDate" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_unref(DatePicker), _mergeProps(field, {
                                    modelValue: values.StartPublishDate,
                                    "onUpdate:modelValue": [($event: any) => ((values.StartPublishDate) = $event), (val) => setFieldValue('StartPublishDate', val)],
                                    masks: {
                            input: 'DD/MM/YYYY'
                          },
                                    "min-date": _unref(moment)().toDate(),
                                    "max-date": values.EndPublishDate
                                  }), {
                                    default: _withCtx(({ togglePopover, inputValue }) => [
                                      _createElementVNode("div", _hoisted_30, [
                                        _createVNode(_unref(InputText), {
                                          id: "start-date",
                                          "aria-describedby": "birth-date-help",
                                          placeholder: "DD-MM-YYYY",
                                          value: inputValue,
                                          onClick: togglePopover,
                                          readonly: ""
                                        }, null, 8, ["value", "onClick"]),
                                        _createElementVNode("span", _hoisted_31, [
                                          _createElementVNode("div", {
                                            innerHTML: _unref(icon).svg.departureScheduleGrey
                                          }, null, 8, _hoisted_32)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1040, ["modelValue", "onUpdate:modelValue", "min-date", "max-date"]),
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(errors.StartPublishDate), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _hoisted_34,
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_unref(Field), { name: "EndPublishDate" }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_unref(DatePicker), _mergeProps(field, {
                                    modelValue: values.EndPublishDate,
                                    "onUpdate:modelValue": [($event: any) => ((values.EndPublishDate) = $event), (val) => setFieldValue('EndPublishDate', val)],
                                    masks: {
                            input: 'DD/MM/YYYY'
                          },
                                    "min-date": values.StartPublishDate
                                  }), {
                                    default: _withCtx(({ togglePopover, inputValue }) => [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createVNode(_unref(InputText), {
                                          id: "end-date",
                                          "aria-describedby": "birth-date-help",
                                          placeholder: "DD-MM-YYYY",
                                          value: inputValue,
                                          onClick: togglePopover,
                                          readonly: ""
                                        }, null, 8, ["value", "onClick"]),
                                        _createElementVNode("span", _hoisted_37, [
                                          _createElementVNode("div", {
                                            innerHTML: _unref(icon).svg.departureScheduleGrey
                                          }, null, 8, _hoisted_38)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"]),
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(errors.EndPublishDate), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_unref(Field), {
                            name: "Notes",
                            as: "textarea",
                            placeholder: "Tulis Keterangan",
                            class: ""
                          }, {
                            default: _withCtx(({ handleChange, handleBlur }) => [
                              _createVNode(_unref(Textarea), {
                                id: "Notes",
                                autocomplete: "nope",
                                autoResize: true,
                                ref: "addressRef",
                                rows: "5",
                                cols: "30",
                                onChange: handleChange,
                                onBlur: handleBlur
                              }, null, 8, ["onChange", "onBlur"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(errors.Notes), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_43,
                          _createVNode(_unref(InputSwitch), {
                            modelValue: isActive.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isActive).value = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (changeIsActive(!isActive.value)))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", null, [
                          _hoisted_45,
                          (_unref(itemList).length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Anda belum menambahkan item apapun. Isi data untuk menambahkan item dalam paket."))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(itemList), (data, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: data,
                                  class: "border-grey-3 p-3 rounded-lg"
                                }, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", {
                                        class: "cursor-pointer",
                                        onClick: ($event: any) => (showItemDetail(index))
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(`pi pi-angle-${_unref(selectedItem) === index ? 'down' : 'right'}`)
                                        }, null, 2)
                                      ], 8, _hoisted_49),
                                      _createElementVNode("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(data.DisplayName ?? '-'), 1),
                                        _hoisted_52,
                                        _createElementVNode("div", _hoisted_53, _toDisplayString(`${_unref(rupiahFormat)(data.BundlePrice ?? 0)} (${_unref(numberFormat)(data.Quantity ?? 0)})`), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("img", {
                                          src: _imports_0,
                                          alt: "edit",
                                          title: "edit",
                                          class: "cursor-pointer",
                                          onClick: ($event: any) => (editItem(data, index))
                                        }, null, 8, _hoisted_55)
                                      ]),
                                      (_unref(itemList).length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, "|"))
                                        : _createCommentVNode("", true),
                                      (_unref(itemList).length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              title: "hapus",
                                              alt: "delete",
                                              class: "cursor-pointer",
                                              onClick: ($event: any) => (deleteItem(data, index))
                                            }, null, 8, _hoisted_58)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  (_unref(selectedItem) === index && _unref(itemList).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        (data.BundleItemType === 'Bus')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              _createElementVNode("div", _hoisted_61, [
                                                _hoisted_62,
                                                _createElementVNode("div", _hoisted_63, _toDisplayString(data.BundleItemRoutes[0]?.TrayekName ?? '-'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _createElementVNode("div", _hoisted_66, _toDisplayString(data.BundleItemRoutes[0]?.ClassName ?? '-'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_67, [
                                                _hoisted_68,
                                                _createElementVNode("div", _hoisted_69, _toDisplayString(data.BundleItemRoutes[0]?.PassengerTypeName ?? '-'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_70, [
                                                _hoisted_71,
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createElementVNode("div", _hoisted_73, _toDisplayString(`${data.BundleItemRoutes[0]?.OriginStationCode ?? '-'} - ${data.BundleItemRoutes[0]?.DestinationStationCode ?? '-'}`), 1),
                                                  (data.BundleItemRoutes.length > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, "|"))
                                                    : _createCommentVNode("", true),
                                                  (data.BundleItemRoutes.length > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(`${data.BundleItemRoutes[1]?.OriginStationCode ?? '-'} - ${data.BundleItemRoutes[1]?.DestinationStationCode ?? '-'}`), 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_76, [
                                                _hoisted_77,
                                                _createElementVNode("div", _hoisted_78, _toDisplayString(`${_unref(rupiahFormat)(data.BundlePrice ?? 0)} (${_unref(numberFormat)(data.Quantity ?? 0)})`), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.BundleItemType === 'Snack')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                              _createElementVNode("div", _hoisted_80, [
                                                _hoisted_81,
                                                _createElementVNode("div", _hoisted_82, _toDisplayString(data.BundleItemSnack?.SnackName ?? '-'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_83, [
                                                _hoisted_84,
                                                _createElementVNode("div", _hoisted_85, _toDisplayString(`${_unref(rupiahFormat)(data.BundlePrice ?? 0)} (${_unref(numberFormat)(data.Quantity ?? 0)})`), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.BundleItemType === 'Voucher')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                              _createElementVNode("div", _hoisted_87, [
                                                _hoisted_88,
                                                _createElementVNode("div", _hoisted_89, _toDisplayString(data.BundleItemVoucher?.Title ?? '-'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_90, [
                                                _hoisted_91,
                                                _createElementVNode("div", _hoisted_92, _toDisplayString(`${_unref(rupiahFormat)(data.BundlePrice ?? 0)} (${_unref(numberFormat)(data.Quantity ?? 0)})`), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", {
                            class: "rounded-lg text-white py-2 px-4 background-blue-primary flex gap-4 items-center justify-between cursor-pointer",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (showDropdown($event)))
                          }, _hoisted_96)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", null, [
                      _hoisted_99,
                      _createElementVNode("div", _hoisted_100, _toDisplayString(_unref(rupiahFormat)(nettPrice.value)), 1),
                      (totalDiscount.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, _toDisplayString(`${_unref(numberFormat)(totalDiscount.value)}%`), 1),
                            _createElementVNode("div", _hoisted_103, _toDisplayString(_unref(rupiahFormat)(brutoPrice.value)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createVNode(_unref(Button), {
                        class: "btn-back",
                        onClick: toMasterList
                      }, {
                        default: _withCtx(() => [
                          _hoisted_105
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        type: "submit",
                        class: "btn-primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_106
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "initial-values"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bundleTypes), (data) => {
          return (_openBlock(), _createElementBlock("div", { key: data }, [
            _createElementVNode("div", _hoisted_107, [
              (data.value === 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: require('@/assets/img/icon/route-outline-black.svg'),
                    alt: "icon-route"
                  }, null, 8, _hoisted_108))
                : _createCommentVNode("", true),
              (data.value === 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/img/icon/voucher-outline-black.svg'),
                    alt: "icon-voucher"
                  }, null, 8, _hoisted_109))
                : _createCommentVNode("", true),
              (data.value === 3)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: require('@/assets/img/icon/pizza-outlined-black.svg'),
                    alt: "icon-snack"
                  }, null, 8, _hoisted_110))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "text-sm",
                onClick: ($event: any) => (addItem(data))
              }, _toDisplayString(data.label), 9, _hoisted_111)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 512),
    (showDialog.value && _unref(selectedBundleType) === 1)
      ? (_openBlock(), _createBlock(ItemForm, {
          key: 1,
          show: showDialog.value,
          index: _unref(selectedItemEdit),
          dataItem: _unref(selectedItemData),
          itemList: _unref(itemList),
          onRefreshHeader: getBundleData,
          onOnSubmitAct: addItemListAct,
          onHideDialog: _cache[6] || (_cache[6] = ($event: any) => (hideDialogAct()))
        }, null, 8, ["show", "index", "dataItem", "itemList"]))
      : _createCommentVNode("", true),
    (showDialog.value && _unref(selectedBundleType) === 2)
      ? (_openBlock(), _createBlock(VoucherForm, {
          key: 2,
          show: showDialog.value,
          index: _unref(selectedItemEdit),
          dataItem: _unref(selectedItemData),
          itemList: _unref(itemList),
          onRefreshHeader: getBundleData,
          onOnSubmitAct: addItemListAct,
          onHideDialog: _cache[7] || (_cache[7] = ($event: any) => (hideDialogAct()))
        }, null, 8, ["show", "index", "dataItem", "itemList"]))
      : _createCommentVNode("", true),
    (showDialog.value && _unref(selectedBundleType) === 3)
      ? (_openBlock(), _createBlock(SnackForm, {
          key: 3,
          show: showDialog.value,
          index: _unref(selectedItemEdit),
          dataItem: _unref(selectedItemData),
          itemList: _unref(itemList),
          onRefreshHeader: getBundleData,
          onOnSubmitAct: addItemListAct,
          onHideDialog: _cache[8] || (_cache[8] = ($event: any) => (hideDialogAct()))
        }, null, 8, ["show", "index", "dataItem", "itemList"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})